<div class="fud" [class.fud--horizontal]="layout === 'horizontal'">
  @if (!displayOnly) {
    <div
      class="fud__dropzone-wrap"
      [class.fud__dropzone-wrap--half]="layout === 'horizontal'"
    >
      <div
        class="fud__dropzone"
        (dragover)="fileDragOver($event)"
        (drop)="fileDrop($event)"
      >
        <i class="bi bi-cloud-arrow-up fud__dropzone-icon"></i>
        <p class="fud__dropzone-title">Drag and drop file here</p>
        <p class="fud__dropzone-hint">or</p>
        <div class="fud__dropzone-actions">
          <button
            type="button"
            class="btn btn-primary"
            [disabled]="disableFileUpload"
            (click)="uploadFile()"
          >
            <i class="bi bi-upload me-1"></i>
            Browse files
          </button>
          <input
            #fileUploadInput
            type="file"
            (change)="selectedFile($event)"
            hidden
          />
          @if (displayNoScanButton) {
            <button
              type="button"
              class="btn btn-outline"
              (click)="uploadFile('No Scan')"
            >
              Browse (no scan)
            </button>
            <input
              #fileUploadInputNoScan
              type="file"
              (change)="selectedFile($event, 'No Scan')"
              hidden
            />
          }
        </div>
      </div>
    </div>
  }

  @if (!displayFilesAsRow) {
    <div
      class="fud__list-wrap"
      [class.fud__list-wrap--half]="layout === 'horizontal'"
    >
      <app-display-card-column
        [displayCardPanelHeight]="'fit'"
        [itemCollection]="Files"
      >
        <ng-template let-item="item" let-index="index">
          <div class="fud__file">
            <i class="bi bi-file-earmark-text fud__file-icon"></i>

            <div class="fud__file-meta">
              <a
                class="fud__file-name"
                (click)="downloadFile(item)"
                href="javascript:void(0)"
                >{{ item.filename }}</a
              >

              <div class="fud__file-sub">
                @if (fileInfoDisplayType === 'default' && item.filesize) {
                  <span>{{ normalizeFileSizeText(item.filesize) }}</span>
                }
                @if (fileInfoDisplayType === 'default' && showFileType) {
                  <span>{{ getFriendlyFileTypeName(item) }}</span>
                }
              </div>
            </div>

            @if (!displayOnly) {
              <div class="fud__file-actions">
                @if (showViewFileButton) {
                  <button
                    type="button"
                    class="btn btn-outline btn-sm"
                    (click)="viewData(item, index)"
                  >
                    View data
                  </button>
                }
                @if (!hideSelectFileButton) {
                  <button
                    type="button"
                    class="btn btn-outline btn-sm"
                    (click)="selectFile(item, index)"
                  >
                    {{ selectFileButtonText }}
                  </button>
                }
                @if (!hideRemoveFileButton) {
                  <button
                    type="button"
                    class="fud__file-remove"
                    [title]="removeFileButtonText"
                    [attr.aria-label]="removeFileButtonText"
                    (click)="removeFile(item, index)"
                  >
                    <i class="bi bi-trash"></i>
                  </button>
                }
              </div>
            }
          </div>
        </ng-template>
      </app-display-card-column>
    </div>
  }

  @if (displayFilesAsRow) {
    <div class="fud__file-grid">
      @for (File of Files; track File; let index = $index) {
        <div class="fud__file fud__file--card">
          <i class="bi bi-file-earmark-text fud__file-icon"></i>

          <div class="fud__file-meta">
            <a
              class="fud__file-name"
              (click)="downloadFile(File)"
              href="javascript:void(0)"
              >{{ File.filename }}</a
            >

            <div class="fud__file-sub">
              @if (fileInfoDisplayType === 'default' && File.filesize) {
                <span>{{ normalizeFileSizeText(File.filesize!) }}</span>
              }
              @if (fileInfoDisplayType === 'default' && showFileType) {
                <span>{{ getFriendlyFileTypeName(File) }}</span>
              }
            </div>
          </div>

          @if (!displayOnly) {
            <div class="fud__file-actions">
              @if (!hideSelectFileButton) {
                <button
                  type="button"
                  class="btn btn-outline btn-sm"
                  (click)="selectFile(File, index)"
                >
                  {{ selectFileButtonText }}
                </button>
              }
              @if (!hideRemoveFileButton) {
                <button
                  type="button"
                  class="fud__file-remove"
                  [title]="removeFileButtonText"
                  [attr.aria-label]="removeFileButtonText"
                  (click)="removeFile(File, index)"
                >
                  <i class="bi bi-trash"></i>
                </button>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>
